import {
  FinancialExchangeRateDetailPage,
  FinancialExchangeRateListPage,
  FinancialMembershipTypeDetailPage,
  FinancialMembershipTypeListPage,
  FinancialPaymentTypeDetailPage,
  FinancialPaymentTypeListPage,
  FinancialProductTransactionDetailPage,
  FinancialProductTransactionListPage,
  FinancialTimestampTransactionCorporationListPage,
  FinancialTimestampTransactionDetailPage,
  FinancialTimestampTransactionListPage,
  FinancialTimestampTransactionReportListPage,
} from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const FinancialBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/financial",
  staticData: {
    TITLE: "Finansal İşlemler",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === FinancialBaseRoute.fullPath)
      throw redirect({
        to: FinancialProductTransactionListRoute.fullPath,
      });
  },
});

export const FinancialProductTransactionBaseRoute = createRoute({
  getParentRoute: () => FinancialBaseRoute,
  path: "/product-transaction",
  staticData: {
    TITLE: "Ürün İşlemleri",
  },
  beforeLoad: (route) => {
    if (
      route.location.pathname === FinancialProductTransactionBaseRoute.fullPath
    )
      throw redirect({
        to: FinancialProductTransactionListRoute.fullPath,
      });
  },
});

export const FinancialProductTransactionListRoute = createRoute({
  getParentRoute: () => FinancialProductTransactionBaseRoute,
  path: "/list",
  component: FinancialProductTransactionListPage,
  staticData: {
    TITLE: "Ürün İşlemleri Listesi",
  },
});

export const FinancialProductTransactionAddRoute = createRoute({
  getParentRoute: () => FinancialProductTransactionBaseRoute,
  path: "/add",
  component: FinancialProductTransactionDetailPage,
  staticData: {
    TITLE: "Yeni Ürün İşlemi",
    PARENT_ROUTE: FinancialProductTransactionListRoute,
  },
});

export const FinancialProductTransactionEditRoute = createRoute({
  getParentRoute: () => FinancialProductTransactionBaseRoute,
  path: "/edit/$id",
  component: FinancialProductTransactionDetailPage,
  staticData: {
    TITLE: "Ürün İşlemi Düzenle",
    PARENT_ROUTE: FinancialProductTransactionListRoute,
  },
});

export const FinancialTimestampTransactionBaseRoute = createRoute({
  getParentRoute: () => FinancialBaseRoute,
  path: "/timestamp-transaction",
  staticData: {
    TITLE: "Zaman Damgası",
  },
  beforeLoad: (route) => {
    if (
      route.location.pathname ===
      FinancialTimestampTransactionBaseRoute.fullPath
    )
      throw redirect({
        to: FinancialTimestampTransactionListRoute.fullPath,
      });
  },
});

export const FinancialTimestampTransactionListRoute = createRoute({
  getParentRoute: () => FinancialTimestampTransactionBaseRoute,
  path: "/list",
  component: FinancialTimestampTransactionListPage,
  staticData: {
    TITLE: "Zaman Damgası Listesi",
  },
});

export const FinancialTimestampTransactionReportListRoute = createRoute({
  getParentRoute: () => FinancialTimestampTransactionBaseRoute,
  path: "/report",
  component: FinancialTimestampTransactionReportListPage,
  staticData: {
    TITLE: "Zaman Damgası Rapor Listesi",
    PARENT_ROUTE: FinancialTimestampTransactionListRoute,
  },
});

export const FinancialTimestampTransactionCorporationListRoute = createRoute({
  getParentRoute: () => FinancialTimestampTransactionBaseRoute,
  path: "/corporation/list/$id",
  component: FinancialTimestampTransactionCorporationListPage,
  staticData: {
    TITLE: "Zaman Damgası Listesi",
    PARENT_ROUTE: FinancialTimestampTransactionListRoute,
  },
});

export const FinancialTimestampTransactionAddRoute = createRoute({
  getParentRoute: () => FinancialTimestampTransactionBaseRoute,
  path: "/add",
  component: FinancialTimestampTransactionDetailPage,
  staticData: {
    TITLE: "Yeni Zaman Damgası",
    PARENT_ROUTE: FinancialTimestampTransactionListRoute,
  },
});

export const FinancialTimestampTransactionEditRoute = createRoute({
  getParentRoute: () => FinancialTimestampTransactionBaseRoute,
  path: "/edit/$id",
  component: FinancialTimestampTransactionDetailPage,
  staticData: {
    TITLE: "Zaman Damgası Düzenle",
    PARENT_ROUTE: FinancialTimestampTransactionListRoute,
  },
});

export const FinancialPaymentTypeBaseRoute = createRoute({
  getParentRoute: () => FinancialBaseRoute,
  path: "/payment-type",
  beforeLoad: (route) => {
    if (route.location.pathname === FinancialPaymentTypeBaseRoute.fullPath)
      throw redirect({
        to: FinancialPaymentTypeListRoute.fullPath,
      });
  },
});

export const FinancialPaymentTypeListRoute = createRoute({
  getParentRoute: () => FinancialPaymentTypeBaseRoute,
  path: "/list",
  component: FinancialPaymentTypeListPage,
  staticData: {
    TITLE: "Ödeme Tipi Listesi",
  },
});

export const FinancialPaymentTypeAddRoute = createRoute({
  getParentRoute: () => FinancialPaymentTypeBaseRoute,
  path: "/add",
  component: FinancialPaymentTypeDetailPage,
  staticData: {
    TITLE: "Ödeme Tipi Oluştur",
    PARENT_ROUTE: FinancialPaymentTypeListRoute,
  },
});

export const FinancialPaymentTypeEditRoute = createRoute({
  getParentRoute: () => FinancialPaymentTypeBaseRoute,
  path: "/edit/$id",
  component: FinancialPaymentTypeDetailPage,
  staticData: {
    TITLE: "Ödeme Tipi Düzenle",
    PARENT_ROUTE: FinancialPaymentTypeListRoute,
  },
});

export const FinancialMembershipTypeBaseRoute = createRoute({
  getParentRoute: () => FinancialBaseRoute,
  path: "/membership-type",
  beforeLoad: (route) => {
    if (route.location.pathname === FinancialMembershipTypeBaseRoute.fullPath)
      throw redirect({
        to: FinancialMembershipTypeListRoute.fullPath,
      });
  },
});

export const FinancialMembershipTypeListRoute = createRoute({
  getParentRoute: () => FinancialMembershipTypeBaseRoute,
  path: "/list",
  component: FinancialMembershipTypeListPage,
  staticData: {
    TITLE: "Üyelik Tipi Listesi",
  },
});

export const FinancialMembershipTypeAddRoute = createRoute({
  getParentRoute: () => FinancialMembershipTypeBaseRoute,
  path: "/add",
  component: FinancialMembershipTypeDetailPage,
  staticData: {
    TITLE: "Üyelik Tipi Oluştur",
    PARENT_ROUTE: FinancialMembershipTypeListRoute,
  },
});

export const FinancialMembershipTypeEditRoute = createRoute({
  getParentRoute: () => FinancialMembershipTypeBaseRoute,
  path: "/edit/$id",
  component: FinancialMembershipTypeDetailPage,
  staticData: {
    TITLE: "Döviz Kuru Düzenle",
    PARENT_ROUTE: FinancialMembershipTypeListRoute,
  },
});

export const FinancialExchangeRateBaseRoute = createRoute({
  getParentRoute: () => FinancialBaseRoute,
  path: "/exchange-rate",
  beforeLoad: (route) => {
    if (route.location.pathname === FinancialExchangeRateBaseRoute.fullPath)
      throw redirect({
        to: FinancialExchangeRateListRoute.fullPath,
      });
  },
});

export const FinancialExchangeRateListRoute = createRoute({
  getParentRoute: () => FinancialExchangeRateBaseRoute,
  path: "/list",
  component: FinancialExchangeRateListPage,
  staticData: {
    TITLE: "Döviz Kuru Listesi",
  },
});

export const FinancialExchangeRateAddRoute = createRoute({
  getParentRoute: () => FinancialExchangeRateBaseRoute,
  path: "/add",
  component: FinancialExchangeRateDetailPage,
  staticData: {
    TITLE: "Döviz Kuru Oluştur",
    PARENT_ROUTE: FinancialExchangeRateListRoute,
  },
});

export const FinancialExchangeRateEditRoute = createRoute({
  getParentRoute: () => FinancialExchangeRateBaseRoute,
  path: "/edit/$id",
  component: FinancialExchangeRateDetailPage,
  staticData: {
    TITLE: "Döviz Kuru Düzenle",
    PARENT_ROUTE: FinancialExchangeRateListRoute,
  },
});

export const FinancialRouteTree = FinancialBaseRoute.addChildren([
  FinancialProductTransactionBaseRoute.addChildren([
    FinancialProductTransactionListRoute,
    FinancialProductTransactionAddRoute,
    FinancialProductTransactionEditRoute,
  ]),
  FinancialTimestampTransactionBaseRoute.addChildren([
    FinancialTimestampTransactionListRoute,
    FinancialTimestampTransactionReportListRoute,
    FinancialTimestampTransactionCorporationListRoute,
    FinancialTimestampTransactionAddRoute,
    FinancialTimestampTransactionEditRoute,
  ]),
  FinancialPaymentTypeBaseRoute.addChildren([
    FinancialPaymentTypeListRoute,
    FinancialPaymentTypeAddRoute,
    FinancialPaymentTypeEditRoute,
  ]),
  FinancialMembershipTypeBaseRoute.addChildren([
    FinancialMembershipTypeListRoute,
    FinancialMembershipTypeAddRoute,
    FinancialMembershipTypeEditRoute,
  ]),
  FinancialExchangeRateBaseRoute.addChildren([
    FinancialExchangeRateListRoute,
    FinancialExchangeRateAddRoute,
    FinancialExchangeRateEditRoute,
  ]),
]);
